import React from "react";
import { useDispatch } from "react-redux";
import { setCapturedImage } from "../../../store/ProfilePhoto/profilePhotoSlice";
import { setOpenModal } from "../../../store/controlPanelSlice";
import CameraCapture from "../../../../../components/AvatarPhoto/CameraCapture";

const ChangePhoto = ({ onClose }) => {
  const dispatch = useDispatch();

  const handleCapture = (img) => {
    dispatch(setCapturedImage(img));
    dispatch(setOpenModal("adjust_photo"));
  };
  return (

    <CameraCapture
      onCapture={handleCapture}
      onClose={onClose}
    />
  );
};

export default ChangePhoto;